import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon, InfoIcon, XIcon } from 'lucide-react';
import { useUiStore } from '../../stores/uiStore';
const icons = {
  success: CheckCircle2Icon,
  error: XCircleIcon,
  info: InfoIcon
};
const tones = {
  success: 'border-emerald-500/40 text-emerald-200',
  error: 'border-red-500/40 text-red-200',
  info: 'border-slate-600 text-slate-200'
};
export function Toaster() {
  const toasts = useUiStore(s => s.toasts);
  const dismiss = useUiStore(s => s.dismissToast);
  return <div className="pointer-events-none fixed bottom-4 right-4 z-[60] flex w-80 flex-col gap-2" data-id="element-219">
      <AnimatePresence data-id="element-220">
        {toasts.map(t => {
        const Icon = icons[t.type];
        return <motion.div key={t.id} layout initial={{
          opacity: 0,
          x: 40
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: 40
        }} className={`pointer-events-auto flex items-start gap-2 rounded-lg border bg-slate-900/95 px-3 py-2.5 text-sm shadow-xl backdrop-blur ${tones[t.type]}`} data-id="element-221">
              <Icon className="mt-0.5 h-4 w-4 shrink-0" data-id="element-222" />
              <span className="flex-1" data-id="element-223">{t.message}</span>
              <button onClick={() => dismiss(t.id)} aria-label="关闭通知" className="text-slate-500 hover:text-slate-300" data-id="element-224">
                <XIcon className="h-4 w-4" data-id="element-225" />
              </button>
            </motion.div>;
      })}
      </AnimatePresence>
    </div>;
}